import { MouseEventHandler } from "react"

import { RadioButton } from "../../../../components/base/control/RadioGroup/RadioButton"
import { classNames } from "../../../../lib/classNames"
import { TableCell, TableCellProps, TableCellWidth } from "../TableCell"

export interface TableRadioButtonCellProps
  extends Omit<TableCellProps, "children" | "width"> {
  isChecked: boolean
  onChangeIsChecked: (isChecked: boolean) => void
}

export function TableRadioButtonCell({
  isChecked,
  onChangeIsChecked,
  className,
  ...otherProps
}: TableRadioButtonCellProps) {
  const onClick: MouseEventHandler<HTMLTableCellElement> = (e) => {
    e.stopPropagation()
    onChangeIsChecked(true)
  }

  return (
    <TableCell
      width={TableCellWidth.ExtraSmall}
      className={classNames(
        "cursor-default border-r-0 text-right align-middle leading-none",
        className
      )}
      onClick={onClick}
      {...otherProps}
    >
      <RadioButton checked={isChecked} />
    </TableCell>
  )
}
